import { LinkStationFormFieldsEnum, yupLocalized } from "@ryde/shared";

export const yupLinkStationValidationSchema = {
  [LinkStationFormFieldsEnum.pickupStation]: yupLocalized
    .number()
    .optional()
    .nullable(),
  [LinkStationFormFieldsEnum.homeAddresses]: yupLocalized
    .array()
    .of(yupLocalized.number().optional())
    .min(0)
    .optional(),
};
